import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import { OTPInput, Button, Step, ActionLink, ModalWindow } from '../../atoms';
import { UserContext } from '../../../context';
import { AuthService } from '../../../services';
import { default as t } from '../../../utils/i18n';


import './verify-otp.scss';

function VerifyOTP({ atStep, updateStep }) {
  const userInitState = {
    username: null,
    name: null,
    tokens: {},
    userConfirmed: null,
    authenticated: null,
    isVerifyOtp: false,
    timestamp: null,
    insights:null
  };
  
  const location = useLocation();
  Modal.setAppElement('#root');
  const { user, setUser } = useContext(UserContext);

  const [otp, setOtp] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [attempted, setAttempted] = useState(1);
  const [validationError, setValidationError] = useState(null);
  const [isMounted, setIsMounted] = useState(false);
  const [disableOtpInput, setDisableOtpInput] = useState(false);
  const [showTimeOutModal, setShowTimeOutModal] = useState(false);
  const [showTimeOutModalError, setShowTimeOutModalError] = useState(null);
  const [isShowTimer, setShowTimer] = useState(false);
  const [timerId, settimerId] = useState(null);


  const getminuteDiff = () => {
    const date_future = new Date().getTime();
    const date_now = new Date(user?.timestamp).getTime();

    let seconds = Math.floor((date_future - (date_now)) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    hours = hours - (days * 24);
    minutes = minutes - (days * 24 * 60) - (hours * 60);
    seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

    return [minutes, seconds];
  }


  useEffect(() => {
    setIsMounted(true);
    if (getminuteDiff()[0] < 15) {
      const minutes = 60 * (15 - getminuteDiff()[0]);
      const seconds = ((15 - getminuteDiff()[0]) < 15) ? 60 - getminuteDiff()[1] : 0;
      const timerValue = minutes + seconds;//need to deduct the timestamp in local storage
       startTimer(timerValue);
      setShowTimer(true);
    }
    else {
      setShowTimeOutModal(true);
      setDisableOtpInput(false);
    }
    if (user?.isVerifyOtp) {
     //  resendOTP();
      setUser(prevUserState => ({
        ...prevUserState,
        isVerifyOtp: false
      }));
    }
    return () => {
      setIsMounted(false);
      if (location) location.state = {};
    };
  }, []);

  const handleChange = otpValue => {
    if (otpValue) {
      setOtp(otpValue);
      setValidationError(null);
    }

    if (otpValue.toString().length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  };

  const startTimer = (duration) => {
    let timer = duration, minutes, seconds;

    const timeout = setInterval(function () {
      minutes = parseInt(timer / 60, 10)
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      const myElement = document.getElementById("time");
      if (myElement) {
        myElement.innerHTML = minutes + ":" + seconds;
      }
      settimerId(timeout);
      if (--timer < 0) {
          clearInterval(timeout);
        setShowTimeOutModal(true);
        setDisableOtpInput(false);
       // setShowTimer(false);
        // if (myElement) {
        //   myElement.innerHTML = "00:00";
        // }
      }
    }, 1000);
   
  }
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const confirmSignUp = await AuthService.confirmSignUp(user.username.toLowerCase(), otp);
      //////console.log(confirmSignUp);
      clearInterval(timerId);
      updateStep(4);
      setUser(prevUserState => ({
        ...prevUserState,
        userConfirmed: true,
        signup: { step: 4 },
      }));
    } catch (error) {
      const errorCode = error.data?.data?.code;
      if (errorCode) {
        setAttempted(prevValue => {
         // ////console.log(prevValue);
          // if (prevValue < 5){
          if (errorCode === "CL_USR_008") {
            setShowTimeOutModalError(t('error.CL_USR_008'));
            setShowTimeOutModal(true);
            setDisableOtpInput(true);
          }
          else {
            setValidationError(t(`error.${errorCode}`));
          }

          setDisableButton(true);
          return prevValue + 1;
          // }
          // else{

          //   setValidationError(t('error.CL_USR_008').replace(/\{(.*?)\}/gi,  '<span id="time">20:00</span>'));
          //   startTimer(timerValue);
          //   setDisableOtpInput(true);
          //   setDisableButton(true);
          //   return prevValue;
          // } 

        });
      }
    }
  };
  const resendOTP = async () => {
    try {
      await AuthService.resendConfirmationCode(user.username.toLowerCase());

    } catch (error) {
      const errorCode = error.data?.data?.code;
      if (errorCode) {
        if (errorCode === "CL_USR_008") {
          // const timerValue = 60 * 20;
          setShowTimeOutModalError(t('error.CL_USR_008'));
          setDisableOtpInput(true);
        }
        else {
          setValidationError(t(`error.${errorCode}`));
        }
      }
    }
  };

  const backtoRetySignup = e => {
    clearInterval(timerId);
    setValidationError(null);
    setShowTimeOutModalError(null);
    localStorage.removeItem('user');
    setUser(userInitState);
    updateStep(1);

  }

  const resetUser = e => {
    //////console.log(timerId);
    e.preventDefault();
    clearInterval(timerId);
    localStorage.removeItem('user');
    setUser(userInitState);
    updateStep(1);
  
  }

  const backtoStep2 = e => {
    e.preventDefault();
    setUser(prevUserState => ({
      ...prevUserState,
      signup: {
        step: 2,
      },
    }));
    updateStep(2);
  }
  if (!isMounted) return null;
  return (
    <div className="ss3-form-container">
     <p className="ss3-heading-email">{user.username}</p>
  <p className="ss3-header">{t('signup.step3.heading')}</p>
      <p className="ss3-title">{t('signup.step3.subHeading')}
    
        {isShowTimer ? (
          <span className="ss3-timer" dangerouslySetInnerHTML={{ __html: t('signup.step3.timeout.timer.message').replace(/\{(.*?)\}/gi, '<span id="time"></span>') }}></span>
        ) : null}

      </p>
      <div className="ss3-footer">
        {t('signup.step3.footer')}{' '}
        <span>
          <ActionLink
            anchor={true}
            target={false}
            value={t('user.link.resend')}
            handleClick={resendOTP}
          />
        </span>
      </div>
      <div className="ss3-input-form-group">
        <form onSubmit={handleSubmit}>
          <div className="input-container">
            <OTPInput
              autoFocus
              name="otp"
              length={6}
              attempted={attempted}
              onChangeOTP={handleChange}
              errorMessage={validationError}
              disabled={disableOtpInput}
            />
          </div>
          <div className="btn-container">
            <Button
              type="submit"
              name="submit"
              label={t('signup.button.verify')}
              disabled={disableButton}
            />
          </div>
        </form>
      </div>
      {/* <div className="ss3-step-container">
        <Step atStep={atStep}></Step>
      </div> */}
      <div className="ss3-signup-container">
        {/* <ActionLink anchor={true}
          target={false}
          value={`${t('signup.step3.signupdiffuser.label')}`}
          handleClick={resetUser} /> */}

<ActionLink anchor={true} value={`< ${t('forgot.common.backLink')}`}  handleClick={backtoStep2} />
      </div>
  
      <ModalWindow
        className="fqa-modal--notification"
        isOpen={showTimeOutModal}
        heading={t('signup.step3.timeout.modal.heading')}
      >
        <h3 className="fqa-model-dash--message">{t('signup.step3.timeout.modal.message')}</h3>
        <div className="fqa-model-dash--actions">
          <Button
            className="fqa-model-dash--actions-reload"
            label={t('signup.step3.timeout.modal.button.label')}
            handleClick={backtoRetySignup}
          />
        </div>
      </ModalWindow>
    </div>
  );
}

export default VerifyOTP;
